// extracted by mini-css-extract-plugin
export default {"dialog-modal-box":"style_dialog-modal-box__UZfjs","video":"style_video__r83IZ"};